import type { PackagesAutocompleteResult } from "@b2bportal/core-packages";
import { useModuleBEM } from "@b2bportal/core-themes";
import type { InputErrorType } from "@b2bportal/core-types";
import { LocationAutocomplete } from "@tenant/ui";
import { fetchLocations } from "./fetchLocations";
import styles from "./PackageLocationAutocomplete.module.scss";
import { usePackageLocationAutocomplete } from "./usePackageLocationAutocomplete";

export interface PackageLocationAutocompleteProps {
  id: string;
  label: string;
  placeholder?: string;
  onChange: (value: PackagesAutocompleteResult) => void;
  onFocus?: () => void;
  value?: PackagesAutocompleteResult;
  density?: "default" | "search";
  error?: InputErrorType;
}

export const PackageLocationAutocomplete = ({
  id,
  label,
  placeholder,
  onChange,
  onFocus,
  value,
  density,
  error,
}: PackageLocationAutocompleteProps) => {
  const [, cn] = useModuleBEM(styles, "PackageLocationAutocomplete");
  const { context, handlers } = usePackageLocationAutocomplete({
    onChange,
    value,
  });

  return (
    <LocationAutocomplete<PackagesAutocompleteResult>
      id={id}
      label={label}
      placeholder={placeholder ?? context.placeholder}
      value={context.value ?? undefined}
      fetch={async (search, callback) => {
        const results = await fetchLocations(search);
        callback(results);
      }}
      onChange={handlers.onChange}
      onFocus={onFocus}
      getOptionLabel={handlers.getOptionLabel}
      getOptionIcon={handlers.getOptionIcon}
      className={density === "default" ? cn("default") : undefined}
      error={error}
      {...(density && { density })}
    />
  );
};
